var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { timeTakenToReply, useSendMessageTracking, useAuthTransitionTracking, analytics, EventCategory, useChatOpenTracking, } from '../../../analytics';
import { LendiMemberType, useChat } from '../../../twilio';
import { TransitionLoader } from '../../Loader';
import { ChatInput } from '../ChatInput';
import ErrorComponent from '../ErrorComponent';
import MessageList from '../MessageList';
import { MessageListWrapper } from '../style';
import { useError } from '../../../providers/ErrorProvider/context';
var TwilioChatComponent = function (_a) {
    var userType = _a.userType, teamMember = _a.teamMember;
    var _b = React.useState(''), messageToSend = _b[0], setMessageToSend = _b[1];
    var _c = React.useState(false), isSendDisabled = _c[0], setIsSendDisabled = _c[1];
    var _d = React.useState(false), messageRead = _d[0], setMessageRead = _d[1];
    var _e = React.useState(-1), lastMessageIndex = _e[0], setLastMessageIndex = _e[1];
    var onException = useError().onException;
    var _f = useChat(), identity = _f.identity, loading = _f.loading, members = _f.members, messages = _f.messages, setMessagesRead = _f.setMessagesRead, error = _f.error, hasMore = _f.hasMore, retryFetch = _f.retryFetch, fetchMore = _f.fetchMore, channel = _f.channel, sendMessage = _f.sendMessage, client = _f.client;
    if (error) {
        return React.createElement(ErrorComponent, { onRetry: retryFetch });
    }
    var sender = members.filter(function (m) { return m.identity === identity; })[0];
    var recipients = members.filter(function (member) { return member.type !== (sender === null || sender === void 0 ? void 0 : sender.type) || member.type !== LendiMemberType.BOT; });
    var onKeyDown = function (e) {
        if (e.key === 'Enter') {
            var customEnterPushedEvent = {
                event_name: 'Return Pressed',
                category: EventCategory.CHAT,
                inputElement: 'message input area',
                noOfCharacters: messageToSend.length,
            };
            analytics(customEnterPushedEvent);
            e.preventDefault();
        }
        // Send Typing Indicator
        channel && channel.typing();
    };
    var scrollToBottom = function () {
        if (displayRef && displayRef.current && displayRef.current.scrollIntoView) {
            displayRef.current.scrollIntoView({ block: 'end', behavior: 'auto' });
        }
    };
    var markMessagesRead = function () {
        timeTakenToReply(sender, recipients, messages, userType, channel === null || channel === void 0 ? void 0 : channel.sid);
        setMessagesRead && setMessagesRead();
    };
    var onInputChange = function (value) {
        setMessageRead(true);
        setMessageToSend(value);
    };
    React.useEffect(function () {
        messageRead && markMessagesRead();
    }, [messageRead]);
    useChatOpenTracking(true);
    // When 'send' is clicked or messages updates Triggering 'read' status from UI
    // TODO: Consider Changing the `sendClicked` UI Trigger to when new message is sent by customer (detect by useEffect(messages))
    React.useEffect(function () {
        // If the update in `messages` are caused by newly sent message (by customer OR broker)
        var lastMessage = messages.length > 0 && messages[messages.length - 1];
        if (lastMessage && lastMessage.index !== lastMessageIndex) {
            // only for updating last message index
            // if (setMessagesRead) setMessagesRead([lastMessage.index]);
            // If sent by customer
            /// / Scroll bottom
            // Else if sent by broker
            /// / Scroll bottom
            /// / TODO: Enhancement: Show dot, until user manually scroll to the end / or type / or send
            scrollToBottom();
            // Else
            /// / Error: Should never happen
            // Update `lastMessageIndex`
            setLastMessageIndex(lastMessage.index);
        }
        else {
            // `messages` update are caused by user scrolling up and loading old messages
            /// / Do nothing
        }
    }, [messages]);
    // The logic that will run, when user opens panel
    React.useEffect(function () {
        if (!loading && members.length > 1) {
            scrollToBottom();
            setMessageRead(true);
        }
    }, [loading, members]);
    var displayRef = React.useRef(null);
    var send = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (messageToSend === '' || loading)
                        return [2 /*return*/];
                    setIsSendDisabled(true);
                    if (!sendMessage) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendMessage(messageToSend)];
                case 2:
                    _a.sent();
                    useSendMessageTracking(messages, userType, sender, channel === null || channel === void 0 ? void 0 : channel.sid);
                    setMessageToSend('');
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    onException(new Error("@lendi/chat: unable to send message to Twilio: ".concat(e_1)));
                    return [3 /*break*/, 4];
                case 4:
                    setIsSendDisabled(false);
                    setMessageRead(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var isChannelMember = members.find(function (member) { return member.identity === identity; }) !== undefined;
    var authViaSmartChat = useAuthTransitionTracking(client, loading);
    var transitionMessage = authViaSmartChat
        ? "Your mobile phone number has been verified.\n\n    We are connecting you with your expert.\n        Please wait for a few moments."
        : 'We are retrieving your chat history. Please wait for a few moments.';
    return client && client.connectionState === 'connected' && !loading ? (React.createElement(React.Fragment, null,
        React.createElement(MessageListWrapper, null,
            React.createElement(InfiniteScroll, { pageStart: 0, loadMore: fetchMore || (function () { }), hasMore: hasMore, isReverse: true, initialLoad: false, useWindow: false },
                identity && (React.createElement(MessageList, { identity: identity, members: members, messages: messages, teamMember: teamMember, userType: userType })),
                React.createElement("div", { ref: displayRef }))),
        React.createElement(ChatInput, { value: messageToSend, disabledSend: isSendDisabled || messageToSend.trim() === '' || !isChannelMember, disabledTextArea: !isChannelMember, onChange: function (e) { return onInputChange(e.target.value); }, send: function () { return send(); }, onKeyDown: onKeyDown }))) : (React.createElement(TransitionLoader, { transitionMessage: transitionMessage }));
};
export default TwilioChatComponent;
//# sourceMappingURL=index.js.map